







































































import { defineComponent, ref, PropType, toRefs, computed, onBeforeMount, onUnmounted } from '@vue/composition-api';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';
import ClockIcon from '@tt4b/ttam-assets/src/svgs/clock.svg';
import EditorDialog from './editor-dialog.vue';
import { CurrencyOption } from './../../../../hooks/creation/account/useCurrencyOption/index';
import { i18n } from './../../../../i18n';
import { getDate } from '@tt4b/ttam-utils';

const name = 'ttam-budget-scheduled-budget';

export default defineComponent({
  name,
  components: {
    TooltipInfo,
    EditorDialog,
    ClockIcon,
  },
  props: {
    adId: {
      type: String,
      required: true,
    },
    currencyOption: {
      type: Object as PropType<CurrencyOption>,
      default: () => ({}),
      required: true,
    },
    timezone: {
      type: String,
      default: '',
      required: true,
    },
    scheduledBudget: {
      type: Number,
      required: true,
    },
    scheduledBudgetTimestamp: {
      type: Number,
      required: true,
    },
    minSchduledBudgetCalculated: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const { scheduledBudget, currencyOption, scheduledBudgetTimestamp, timezone } = toRefs(props);
    const showEditorDialog = ref(false);
    const timerId = ref();
    const timerNow = ref(Date.now());

    const scheduledBudgetTimeFormat = computed(() => `YYYY-MM-DD HH:mm [(UTC]Z [ ${i18n.t('time_tomorrow')})]`);

    const scheduledBudgetDetail = computed(() => {
      const budget = scheduledBudget.value || 0;
      let scheduledBudgetEffectiveTime = '';
      if (scheduledBudget.value && scheduledBudgetTimestamp.value) {
        const time = getDate(timezone.value)(scheduledBudgetTimestamp.value * 1000);

        scheduledBudgetEffectiveTime = time.format(scheduledBudgetTimeFormat.value);
      }

      return i18n.t('adgroup_scheduled_budget_detail', {
        date: scheduledBudgetEffectiveTime,
        budget: budget.toFixed(currencyOption.value?.precision) + currencyOption.value?.currency,
      });
    });

    const scheduledBudgetDetailVisible = computed(() => Boolean(scheduledBudget.value));

    /** 23点55分到 00:00 禁止编辑 */
    const scheduledBudgetEditable = computed(() => {
      const now = getDate(timezone.value)(timerNow.value);

      return !(now.hour() === 23 && now.minute() >= 55);
    });

    onBeforeMount(() => {
      timerId.value = window?.setInterval?.(() => {
        timerNow.value = Date.now();
      }, 1000);
    });

    onUnmounted(() => {
      window?.clearInterval?.(timerId.value);
    });

    const handleEditClick = () => {
      if (!scheduledBudgetEditable.value) {
        return;
      }
      showEditorDialog.value = true;
    };
    return {
      name,
      showEditorDialog,
      scheduledBudgetDetail,
      scheduledBudgetDetailVisible,
      scheduledBudgetEditable,
      handleEditClick,
    };
  },
});
